import { PostHogConfig } from "posthog-js";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { env } from "../../env";

const enabled = process.env.NODE_ENV === "production"; // not using vite mode because we want to use sentry in staging etc. as well

export const posthogConfig: {
  options: Partial<PostHogConfig>;
  apiKey: string | undefined;
} = {
  options: {
    api_host: env.posthogHost,
    persistence: "memory", // cookieless mode, see https://posthog.com/tutorials/cookieless-tracking
    autocapture: true,
    capture_pageview: false,
    debug: import.meta.env.DEV,
  },
  apiKey: enabled ? env.posthogKey : undefined,
};

export const getStationSlugFromPath = (pathname: string): string | undefined =>
  matchPath("/stations/:stationSlug/*", pathname)?.params.stationSlug ??
  matchPath("/stations/:stationSlug", pathname)?.params.stationSlug;

const getStationSlugFromLocation = (
  pathname: string,
  search: string,
): string | undefined => {
  const stationSlugFromPath = getStationSlugFromPath(pathname);
  if (stationSlugFromPath) {
    return stationSlugFromPath;
  }

  const stationSlugFromQuery = new URLSearchParams(search)
    .get("stationSlug")
    ?.trim();
  return stationSlugFromQuery === "" ? undefined : stationSlugFromQuery;
};

export const useTrackPageView = (): void => {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    const url = window.origin + location.pathname + location.search;
    const stationSlug = getStationSlugFromLocation(
      location.pathname,
      location.search,
    );

    if (stationSlug) {
      posthog.register({ stationSlug });
    } else {
      posthog.unregister("stationSlug");
    }

    posthog.capture("$pageview", {
      $current_url: url,
      ...(stationSlug ? { stationSlug } : {}),
    });
  }, [posthog, location]);
};
